import { CSSProperties } from 'react'
import { Typography, styled, Stack, IconButton } from '@mui/material'
import { formatClock } from '$func/date'
import { t } from '$i18n'
import { PinMessage } from '$common/icons'
import { MessageMenuIcon } from '$comp/_app/components/chat/components/body/components/messageList/messages/components/menu-icon'
import { MESSAGE_VIEW_COUNT_IS_ENABLED } from '$config/env'
import { Views } from './views'
import { SendStatus } from './send-status'

const Root = styled('div')<{ fromMe: boolean }>`
  display: flex;
  height: 14px;
  flex-direction: row-reverse;
  align-items: center;
  position: absolute;
  /* @noflip */
  left: 10px;
  bottom: 8px;
`

const TimeTypography = styled(Typography)`
  line-height: 12px;
  flex-shrink: 0;
  padding-top: 2px;
  /* @noflip */
  margin-right: 8px;
`

const StyledPinIcon = ({ fromMe }: { fromMe: boolean }) => (
  <PinMessage
    sxProps={{
      color: fromMe ? 'neutral000' : 'neutral500',
      width: '14px',
      height: '14px',
      marginRight: '4px',
    }}
  />
)

const IconContainer = styled(Stack)`
  display: contents;
  /* @noflip */
  margin-right: 4px;
`

const MenuIconContainer = styled(IconButton)`
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
`

interface Props {
  iid: number
  time?: Date
  edited?: boolean
  canShowStatus: boolean
  overrideStyle?: CSSProperties
  viewCount: number
  pinned: boolean
  fromMe: boolean
  isWapp: boolean
  roomId: string
}

export function TimeAndStatus({
  iid,
  time,
  edited,
  canShowStatus,
  overrideStyle,
  viewCount,
  pinned,
  fromMe,
  isWapp,
  roomId,
}: Props) {
  return (
    <Root fromMe={fromMe} style={overrideStyle}>
      <IconContainer>
        {canShowStatus && <SendStatus iid={iid} fromMe={fromMe} />}
        {time && (
          <TimeTypography
            variant="caption1"
            color={fromMe ? 'neutral000' : 'neutral500'}
          >
            {formatClock(time)}
          </TimeTypography>
        )}
        {MESSAGE_VIEW_COUNT_IS_ENABLED && <Views views={viewCount} fromMe={fromMe} />}
        {pinned && <StyledPinIcon fromMe={fromMe} />}
      </IconContainer>

      {edited && (
        <Typography
          sx={{
            marginRight: '8px',
          }}
          flexShrink={0}
          variant="caption2"
          color={fromMe ? 'neutral000' : 'neutral500'}
        >
          {t('message.edited')}
        </Typography>
      )}
      {isWapp && (
        <MessageMenuIcon
          iid={iid}
          fromMe={fromMe}
          roomId={roomId}
          IconButton={MenuIconContainer}
        />
      )}
    </Root>
  )
}

TimeAndStatus.defaultProps = {
  time: null,
  edited: false,
  overrideStyle: null,
}
